import { Injectable } from '@angular/core';
import {ValidateService} from "../../modules/validate/validate.service";
import {ToastrService} from "ngx-toastr";
import {MessageService} from "../../services/message.service";
import {FormService} from "../../services/form.service";

@Injectable({
  providedIn: 'root'
})
export class FormEntityExtensionService {

  constructor(public validateService: ValidateService,
              public toastrService: ToastrService,
              public messageService: MessageService,
              public formService: FormService) {
  }
}
